export class Trade {
    id: number;
    name: string;
    disable?: boolean;
}
